<template>
  <div class="exam-question__slide">
    <div class="exam-question__slide__head">
      <h3 class="font-size-20 primary-color-txt font-sanpro-semibold">Đề thi</h3>
    </div>
    <div class="exam-question__slide__list position-rel">
      <swiper v-if="dataSource && dataSource.length > 0" class="swiper" :options="swiperOption" >
        <swiper-slide v-for="(item, index) of dataSource" :key="index" v-show="item.numberQuestion">
          <div class="item__wrap position-rel text-center">
            <div class="item__head aspect-ratio aspect-ratio--16-9">
              <a href="javascript:;" @click="handleViewQuestionByChapter(item)">
                <img class="inner-img" v-lazy="item.contentURL &&  item.contentURL !== null ?cdnUrl+item.contentURL: img404">
              </a>
            </div>
            <div class="item__body">
              <h3 class="item__name font-size-18 font-sanpro-semibold primary-color-txt" @click="handleViewQuestionByChapter(item)">
                <a href="javascript:;"  class="primary-color-txt">
                  {{item.name}}
                </a>
              </h3>
                <!-- <p class="margin-0 secondary-color-txt font-size-14"> {{ item.countQuestionDone }} / {{ item.countQuestion }}</p> -->
            </div>
          </div>
        </swiper-slide>
        <div class="swiper-button-prev question_slide_prev" slot="button-prev"></div>
        <div class="swiper-button-next question_slide_next" slot="button-next"></div>
        <!-- <div class="slider-btn slider-btn__prev book__active__btn__prev display-flex-center justify-content-center">
          <div class="slider-btn__wrap position-rel">
            <div
              class="swiper-button-prev question_slide_next book__active__btn__slider"
              slot="button-prev"
            ></div>
          </div>
        </div>
        <div class="slider-btn slider-btn__next book__active__btn__next display-flex-center justify-content-center">
          <div class="slider-btn__wrap position-rel">
            <div
              class="swiper-button-next question_slide_prev text-right book__active__btn__slider"
              slot="button-next"
            ></div>
          </div>
        </div> -->
      </swiper>
      <p v-else class="secondary-color-txt font-size-18 text-center">Không có dữ liệu phù hợp</p>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import "swiper/dist/css/swiper.css";
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import { APP_CONFIG } from "@/utils/constants"
import { STORE_KEY } from './../../_store/constants'
    
import { apiGetListQuestionByChapterId } from './../../_api/exam'
const img404 = require('@/assets/images/img_404.jpg')

export default {
  name: 'ModalQuestionsAutoTest',
  props: {
    dataSource: Array
  },
  components: {
    swiper,
    swiperSlide
  },
  data () {
    return {
      img404,
      cdnUrl: APP_CONFIG.cdnUrl,
      swiperOption: {
        slidesPerView: 4,
        spaceBetween: 30,
        slidesPerGroup: 2,
        loop: true,
        loopFillGroupWithBlank: true,
        navigation: {
          nextEl: '.question_slide_next',
          prevEl: '.question_slide_prev'
        }
      },
    }
  },
watch: {
    paramFilterQuestionsByChapter: 'getQuestions'
  },
  computed: {
    ...mapState(STORE_KEY, ['paramFilterQuestionsByChapter'])
  },
  methods: {
    ...mapActions('common', ['setLoading']),
    ...mapActions(STORE_KEY, ['acSetChapterIdQuestions', 'acSetParamsFilterQuestionChapter','acSetQuestionSample']),

    handleViewQuestionByChapter (data) {
      // this.acSetChapterIdQuestions(data.chapterId)
      this.acSetParamsFilterQuestionChapter({...this.paramFilterQuestionsByChapter,examId:  data.examId})
    },
    getQuestions () {
      let self = this
      self.setLoading(true)
      apiGetListQuestionByChapterId(self.paramFilterQuestionsByChapter).then(res => {
        res && self.acSetQuestionSample(res.data)
      }).finally(() => self.setLoading(false))
    }
  }
}
</script>

<style lang="scss" scoped>
.exam-question__slide{
  margin-bottom: 50px;
    &__head{
      border-bottom: 1px solid #E5E5EA;
      margin-bottom: 15px;
    }
}
.slider-btn {
  background: rgba(255,255,255,.3);
  position: absolute;
  top: 0;
  bottom: 0;
  width: 35px;
  height: 100%;
  z-index: 5;

  &__prev {
    left: 0;
  }

  &__next {
    right: 0;
  }

  .swiper-button-next {
    right: -8px;
  }
  .swiper-button-prev {
    left: -8px;
  }
}
</style>
